<template>
    <div class="div">
        <transition name="fade">
            <div v-show="showForm" class="form collapsed" :class="{deployed: active}">
                <a class="close" @click="close" v-if="!$root.isMobile || showCloseMobile"></a>
                <a class="open" :class="{close: active}" v-else @click="sub"></a>
                <form class="":class="{hidden_form : shows}" @submit.prevent="check" action="" method="POST" novalidate="true">
                    <span class="desc" @click="sub">
                        <!--Получите промо-код <br>на скидку 15%. <br>Введите свой e-mail-->
                        Оставьте свой e-mail и&nbsp;получите скидку&nbsp;15% на&nbsp;первый заказ в&nbsp;интернет-магазине <a href="https://www.weleda.ru/" target="_blank">www.weleda.ru</a>
                    </span>
                    <input  type="email" name="email" v-model="email" placeholder="Ваш e-mail">
                    <p v-if="formErrors.length">
                        <span class="err" v-for="error in formErrors">{{ error }}</span>
                    </p>
                    <transition name="fade">
                        <button type="submit">Получить</button>
                    </transition>
                    <p class="inform"><a href="/static/pdf/Personal-information.pdf" download="Personal information">Условия и&nbsp;способы обработки и&nbsp;хранения персональных данных</a></p>
                </form>
                <div v-show="shows" class="code">
                    <p>Ваш промокод: LEMON</p>
                    <p><a href="https://www.weleda.ru/" @click="gaEvents('product','click','linkpopup')" target="_blank" >www.weleda.ru</a></p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import Helpers from '@/tools/Helpers';

    export default {
        name: 'popup',
        data(){
            return {
                active: '',
                formErrors: [],
                email: '',
                shows: false,
                show: true,
            }
        },
        props: {
            showForm: {
                type: [Boolean],
                required: false,
                default: true
            },
            showCloseMobile: {
                type: [Boolean],
                required: false,
                default: false
            }
        },

        methods: {
            gaEvents(ctegory,event,label){
                Helpers.ga().send(ctegory,event,label);
            },

            sub() {
                this.active = this.$store.getters['SET_FORM'];
                this.$store.commit('SET_FORM',!this.active);
            },

            check(e) {

                this.gaEvents('main','click','sent e-mail');

                this.formErrors = [];
                if(!this.email) {
                    this.formErrors.push("Укажите электронную почту.");
                } else if(!this.validEmail(this.email)) {
                    this.formErrors.push("Укажите корректный адрес электронной почты.");
                }

                let data = {
                    email: this.email,
                };

                if(!this.formErrors.length){
                    this.$store.dispatch('SEND_FORM', data).then((result) => {
                        this.shows = true;
                    });

                    return true;
                }

                e.preventDefault();
            },

            validEmail(email) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            close() {
                this.$emit('closeForm');
                this.gaEvents('main','click','close popup');
            }

        },

        computed: {
            getStatus() {
                return this.$store.getters['SET_FORM'];
            },
        }
    }
</script>

<style>

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

</style>


// WEBPACK FOOTER //
// Form.vue?f44d8b02